import { memo } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  ExpandableText,
} from "@cointervue/design-system/components";
import type { JobDescriptionCardProps } from "@cointervue/shared/types/commonTypes";

function JobDescriptionCard({ title, description }: JobDescriptionCardProps) {
  return (
    <Card className="p-6 w-[90%] ml-5 my-2">
      <CardHeader className="p-0">
        <CardTitle> {title}</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <ExpandableText lineClampClass="line-clamp-6">
          <CardDescription className="mt-2 leading-relaxed">
            {description.split("\n").map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
          </CardDescription>
        </ExpandableText>
      </CardContent>
    </Card>
  );
}

export default memo(JobDescriptionCard);
